/** @jsx jsx */
/* eslint-disable no-use-before-define */

import useRecentSearches from './use-recent-searches'
import {Flyout, mediaQueries, parseHtml} from '../../twd'
import {jsx} from '@emotion/core'

export default ({refresh, onSearch}) => {
    const { status, Loading, recentSearches } = useRecentSearches({refresh})

    return (
        <div
            data-name="global-search-recent-searches"
            className="col-xs-12 col-md-6" css={style}>
        <div className="text-bold">Recent Searches</div>
        <Loading status={status} spinner={false}>
        {
            recentSearches.map( (a,i) => (
                <div key={i}
                    data-name="global-search-recent-search"
                    className="auto-suggest-menu-item"
                    item={a}
                    onClick={() => onSearch(a)}>
                    <Flyout
                        trigger={['hover']}
                        showIcon={false}
                        isButton={false}
                        html={parseHtml(a.description)}
                        className='link-button'
                        labelStyle={{width:'100%'}}
                        trackMouseOnTip={false}
                        label={<span style={{display:'block'}} className="text-truncate">{a.description}</span>}
                    />
                </div>
            ))
        }
        </Loading>
        </div>)
}

const style = {
    [mediaQueries.notXs]: {
        float:'left',
        paddingBottom:'100%',
        marginBottom:'-100%',
        borderRight:'1px solid #e4e4e4'
    }
}